var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-100"},[_c('small',[_vm._v(_vm._s(_vm.label))]),(!_vm.$slots || !_vm.$slots.length || !_vm.$slots.default)?_c('p',{staticClass:"m-0 p-0"},[_vm._v(" "+_vm._s(_vm.content)+" ")]):_vm._e(),_vm._t("default"),(!_vm.hideHr)?_c('hr'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }